import { render, staticRenderFns } from "./Jdb.vue?vue&type=template&id=1c5b2544&scoped=true&"
import script from "./Jdb.vue?vue&type=script&lang=js&"
export * from "./Jdb.vue?vue&type=script&lang=js&"
import style0 from "./Jdb.vue?vue&type=style&index=0&id=1c5b2544&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5b2544",
  null
  
)

export default component.exports